import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

class RouterNoMatch extends React.Component<RouteComponentProps> {
  public constructor(props: RouteComponentProps) {
    super(props)

    this.props.history.push('/')
  }

  public render() {
    return <div />
  }
}

export default withRouter(RouterNoMatch)



// WEBPACK FOOTER //
// ./src/components/RouterNoMatch/RouterNoMatch.tsx